var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.room
    ? _c(
        "div",
        [
          _c("div", { staticClass: "d-flex justify-space-between" }, [
            _c("div", { staticClass: "va-subtitle font-bold" }, [
              _vm._v(_vm._s(_vm.$t("common.information")))
            ]),
            _c("div", { staticClass: "va-subtitle font-bold grey--text" }, [
              _vm._v(" " + _vm._s(_vm.$t("common.scheduler")) + " ")
            ])
          ]),
          _c("div", { staticClass: "va-subtitle-s" }, [
            _vm._v(_vm._s(_vm.$t("common.details")))
          ]),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("common.licenseKey") } },
                    [_vm._v(_vm._s(_vm.room.licenseKey) + " ")]
                  ),
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("common.maintenance") } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _c("span", { staticClass: "mr-1" }, [
                            _vm._v(
                              _vm._s(
                                _vm.room.isMaintenanceModeEnabled
                                  ? _vm.$t("common.maintenance")
                                  : _vm.$t("common.available")
                              )
                            )
                          ]),
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: "",
                                color: _vm.room.isMaintenanceModeEnabled
                                  ? "purple"
                                  : "secondary"
                              }
                            },
                            [_vm._v("vi vi-shape-oval ")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("common.agentVersion") } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.room.workerVersion || _vm.$t("common.unknown")
                        ) + " "
                      )
                    ]
                  ),
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("roomDetail.deviceType") } },
                    [
                      _c("img", {
                        staticStyle: { width: "22px" },
                        attrs: {
                          src: require("@/assets/images/deviceTypes/apple.svg"),
                          alt: "ios"
                        }
                      })
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("div", { staticClass: "va-subtitle-s" }, [
                    _vm._v(_vm._s(_vm.$t("common.lastStatus")))
                  ]),
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("common.lastStatus") } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("formatDateTime")(_vm.room.lastUpdate)
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }